<template>
  <div />
</template>

<script>
/**
 * Vue: Site Footer (site-footer)
 * -----------------------------------------------------------------------------
 * Site footer component with accordion display of links.
 *
 */
export default {
  name: 'SiteFooter',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  mounted() {
    document
      .querySelectorAll(
        `#vue-element #shopify-section-${this.liquid.sectionId} a.site-footer__navigation-link`,
      )
      .forEach((item) => {
        item.addEventListener('click', () => {
          this.handleTrackingLinkClick(item, 'footer');
        });
      });

    document
      .querySelectorAll(
        `#vue-element #shopify-section-${this.liquid.sectionId} a.site-footer__social-icon`,
      )
      .forEach((item) => {
        item.addEventListener('click', () => {
          this.handleTrackingSocialLinkClick(item);
        });
      });
  },

  methods: {
    /**
     * Handle link click for dataLayer.
     * @param {Object} item - Dropdown item.
     * @param {String} navElement - Parent section.
     */
    handleTrackingLinkClick(item, navElement) {
      cnvs.EventBus.emit('dataLayer:navigation_select', {
        event: 'navigation_select',
        click_item: `${item.dataset.breadcrumbs ?? ''}${item.dataset.title}`,
        nav_element: navElement,
      });
    },

    /**
     * Handle outbound social link click for dataLayer.
     * @param {Object} item - Social item clicked.
     */
    handleTrackingSocialLinkClick(item) {
      cnvs.EventBus.emit('dataLayer:outbound_social_links', {
        event: 'outbound_social_links',
        outbound_social_links: {
          social_network: item.dataset.title,
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import './site-footer';
</style>
